import { Box } from "@mui/material";
import { AppBar, TitlePortal } from "react-admin";

export const AuAppBar = () => (
  <AppBar
    color="inherit"
    position="fixed"
    elevation={0}
    sx={{
      bgcolor: "background.default",
      color: "text.primary",
      borderBottom: 1,
      borderColor: "divider",
    }}
  >
    <TitlePortal />
    <Box
      sx={{
        display: { xs: "none", sm: "flex" },
        justifyContent: "right",
        flexGrow: 1,
      }}
    ></Box>
  </AppBar>
);
